var Backbone, SupportOrderListElementViewTemplate, SupportOrderView, SupportUtilsHelper,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportOrderListElementViewTemplate = require('../../../order_list_element_view.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

SupportUtilsHelper = require('../../helpers/utils');

SupportOrderView = (function(superClass) {
  extend(SupportOrderView, superClass);

  function SupportOrderView() {
    return SupportOrderView.__super__.constructor.apply(this, arguments);
  }

  SupportOrderView.prototype.tagName = 'tr';

  SupportOrderView.prototype.className = 'orderTableRow';

  SupportOrderView.prototype.initialize = function() {
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    return this.template = SupportOrderListElementViewTemplate;
  };

  SupportOrderView.prototype.renderSingleItem = function(order) {
    var data;
    data = this.toHash(order);
    this.$el.html(toHtml(this.template, data, this.I18nScope));
    this.$el.attr('key', data.id);
    this.$el.attr('dateStr', data.purchasedAt);
    return data;
  };

  SupportOrderView.prototype.renderEmptyTemplate = function() {
    var data;
    data = {
      showMultipleColumns: true,
      hasData: false
    };
    return toHtml(this.template, data, this.I18nScope);
  };

  SupportOrderView.prototype.replaceEmptyTemplateWithOrderTemplate = function(emptyTd, order) {
    var data;
    data = this.toHash(order);
    data.showMultipleColumns = true;
    data.hasData = true;
    return emptyTd.replaceWith(toHtml(this.template, data, this.I18nScope));
  };

  SupportOrderView.prototype.renderMultipleItems = function(orders) {
    return _.each(orders, (function(_this) {
      return function(order) {
        var data;
        if (order) {
          data = _this.toHash(order);
          data.showMultipleColumns = true;
          data.hasData = true;
          return _this.$el.append(toHtml(_this.template, data, _this.I18nScope));
        }
      };
    })(this));
  };

  SupportOrderView.prototype.toHash = function(order) {
    var data;
    data = (function() {
      switch (order.DEAL_TYPE) {
        case 'GETAWAYS_TONIGHT':
          return this.reservationHash(order);
        case 'GETAWAYS_MARKET_RATE':
          return this.reservationHash(order);
        case 'GETAWAYS_BOOKING':
          return this.getawaysBookingHash(order);
        default:
          return this.orderHash(order);
      }
    }).call(this);
    return data;
  };

  SupportOrderView.prototype.orderHash = function(order) {
    var data, quantity, ref, ref1, ref2, ref3, ref4;
    quantity = order.quantity;
    if (quantity == null) {
      quantity = SupportUtilsHelper.findGrouponQuantity(order.groupons);
    }
    data = {
      id: order.id,
      imageUrl: ((ref = order.deal) != null ? ref.smallImageUrl : void 0) || ((ref1 = order.deal) != null ? ref1.sidebarImageUrl : void 0) || ((ref2 = order.deal) != null ? ref2.mediumImageUrl : void 0),
      merchant: (ref3 = order.merchant) != null ? ref3.name : void 0,
      purchasedAt: order.purchasedAtshortDatetimeStr,
      qty: quantity,
      title: (ref4 = order.deal) != null ? ref4.title : void 0
    };
    return data;
  };

  SupportOrderView.prototype.getawaysBookingHash = function(order) {
    var data, ref, ref1, ref2, reservationSource;
    reservationSource = SupportUtilsHelper.getReservationSource(order);
    data = {
      id: order.id,
      imageUrl: ((ref = order.deal) != null ? ref.sidebarImageUrl : void 0) || ((ref1 = order.deal) != null ? ref1.mediumImageUrl : void 0) || ((ref2 = order.deal) != null ? ref2.smallImageUrl : void 0),
      merchant: reservationSource != null ? reservationSource.hotelName : void 0,
      purchasedAt: order.purchasedAtshortDatetimeStr,
      title: reservationSource != null ? reservationSource.roomNameHtml : void 0,
      checkInDate: reservationSource != null ? reservationSource.formattedCheckInShortDate : void 0,
      checkOutDate: reservationSource != null ? reservationSource.formattedCheckOutShortDate : void 0,
      showReservatioinDates: true
    };
    return data;
  };

  SupportOrderView.prototype.reservationHash = function(order) {
    var data, reservationSource;
    reservationSource = SupportUtilsHelper.getReservationSource(order);
    data = {
      id: order.id,
      imageUrl: order.imageUrl,
      merchant: reservationSource != null ? reservationSource.hotelName : void 0,
      purchasedAt: order.purchasedAtshortDatetimeStr,
      title: reservationSource != null ? reservationSource.roomNameHtml : void 0,
      checkInDate: reservationSource != null ? reservationSource.formattedCheckInDate : void 0,
      checkOutDate: reservationSource != null ? reservationSource.formattedCheckOutDate : void 0,
      showReservatioinDates: true
    };
    return data;
  };

  return SupportOrderView;

})(Backbone.View);

module.exports = SupportOrderView;

//# sourceMappingURL=data:application/json;base64,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
